import React from 'react';
import { Field, FieldLabel, FieldDescription } from '@/components/ui/field';
import { Input } from '@/components/ui/input';
import { Switch } from '@/components/ui/switch';
import { Button } from '@/components/ui/button';

export default function StepIdentification({ formik, onNext }) {
  const handleNext = async e => {
    e.preventDefault();
    await formik.setTouched({ name: true, description: true, target_audience: true });
    const errors = await formik.validateForm();
    if (errors.name || errors.target_audience) return;
    onNext();
  };

  return (
    <div className="page page--wrap">
      <div className="page__col">
        <form
          className="form form--step-by-step"
          method="post"
          onSubmit={handleNext}
        >
          <div className="page__content mb-12 animate-fade-in">
            <div className="new-questions__header">
              <h2 className="new-questions__title">Identificação</h2>
            </div>

            <div className="flex animate-fade-in flex-col gap-6">
              <Field>
                <FieldLabel htmlFor="name">* Nome</FieldLabel>
                <Input
                  id="name"
                  name="name"
                  type="text"
                  placeholder="Ex: Seletivo 2026"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  aria-invalid={Boolean(formik.touched.name && formik.errors.name)}
                />
                {formik.touched.name && formik.errors.name && <FieldDescription className="text-danger">{formik.errors.name}</FieldDescription>}
              </Field>

              <Field>
                <FieldLabel htmlFor="description">Descrição</FieldLabel>
                <textarea
                  id="description"
                  name="description"
                  rows={4}
                  className="mt-1 w-full rounded border p-2"
                  placeholder="Descreva o processo seletivo..."
                  value={formik.values.description}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.description && formik.errors.description && <FieldDescription className="text-danger">{formik.errors.description}</FieldDescription>}
              </Field>

              <Field>
                <FieldLabel>* Público alvo</FieldLabel>
                <div className="mt-2 flex gap-6">
                  <label className="flex cursor-pointer items-center gap-2">
                    <input
                      type="radio"
                      name="target_audience"
                      value="student"
                      checked={formik.values.target_audience === 'student'}
                      onChange={formik.handleChange}
                      disabled={formik.values.editable_target_audience === false}
                      className="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500"
                    />
                    <span className="text-sm">Aluno</span>
                  </label>
                  <label className="flex cursor-pointer items-center gap-2">
                    <input
                      type="radio"
                      name="target_audience"
                      value="teacher"
                      checked={formik.values.target_audience === 'teacher'}
                      onChange={formik.handleChange}
                      disabled={formik.values.editable_target_audience === false}
                      className="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500"
                    />
                    <span className="text-sm">Professor</span>
                  </label>
                </div>
                {formik.touched.target_audience && formik.errors.target_audience && <FieldDescription className="mt-1 text-danger">{formik.errors.target_audience}</FieldDescription>}
                {formik.values.editable_target_audience === false && <FieldDescription className="mt-1 text-warning">Não é possível alterar o público após a primeira inscrição.</FieldDescription>}
                {formik.values.target_audience === 'teacher' && <FieldDescription className="mt-1">Configure as perguntas (formação, disciplinas, currículo) na etapa &ldquo;Perguntas&rdquo; do wizard.</FieldDescription>}
              </Field>

              {formik.values.target_audience === 'student' && (
                <Field>
                  <div className="flex items-center justify-between gap-3">
                    <div>
                      <FieldLabel htmlFor="collect_education_info">Coletar dados de escolaridade</FieldLabel>
                      <FieldDescription>Quando desligado, o formulário público omite escolaridade atual, série pretendida e turno (útil para seletivos de eventos).</FieldDescription>
                    </div>
                    <Switch
                      id="collect_education_info"
                      checked={formik.values.collect_education_info !== false}
                      onCheckedChange={checked => formik.setFieldValue('collect_education_info', checked)}
                    />
                  </div>
                </Field>
              )}
            </div>
          </div>

          <div className="flex">
            <Button
              type="submit"
              variant="default"
              size="md"
              wide
            >
              Próximo
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
